import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import Headings from "@components/Headings";
import BButton from "@components/BButton";

interface SignupSectionProps {
  title: string;
  body: string;
  button: string;
  link: string;
}

const SignupSection: React.FC<SignupSectionProps> = ({ title= '', body= '', button = '', link = 'quiz'}) => {
  const href = `https://get-base.com/${link}`
  return (
    <SignupSectionContainer>
      <SignupSectionContentContainer>
        <SignupSectionContentTitle>
          { title }
        </SignupSectionContentTitle>
        <SignupSectionContentBodyContainer>
          <SignupSectionContentBody>
            { body }
          </SignupSectionContentBody>
          <SignupSectionContentButtonContainer>
            <BButton
              text={button}
              href={href}
              rounded={true}
            />
          </SignupSectionContentButtonContainer>
        </SignupSectionContentBodyContainer>
      </SignupSectionContentContainer>
    </SignupSectionContainer>
  );
};

const SignupSectionContainer = styled.div`
  padding: 24px;
  background: #000000;
`;

const SignupSectionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const SignupSectionContentTitle = styled(Headings.h3)`
  color: #ffffff;
  padding-bottom: 40px;
  margin: 0 !important;
  text-transform: uppercase;
  letter-spacing: -0.02em;
  
  ${mediaqueries.phablet`
    padding: 0 0 32px 0 !important;
  `};
`;

const SignupSectionContentBodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  
  ${mediaqueries.phablet`
    flex-direction: column;
    align-items: flex-start;
  `};
`;
const SignupSectionContentBody = styled.p`
   flex: 1 0;
   margin-bottom: 0;
   color: #ffffff;
   padding-right: 100px;
   letter-spacing: -0.02em;
   line-height: 21px;
   
   ${mediaqueries.phablet`
    padding: 0;
    padding-bottom: 32px;
  `};
`;

const SignupSectionContentButtonContainer = styled.div`
  ${mediaqueries.phablet`
    width: 100%;
  `};
`;

export default SignupSection;
